import { actionTypes } from '../actions/campaigns.action';
const initialState = {
    accounts: [],
    status: [],
    chart: {
        period: {
            period_chart: [],
            today: {}, 
            campaigns: [],
            stats: {}
        },
        hour: {
            best_hour: {},
            best_window: {},
            hourly_chart: [],
            campaigns: [],
        },
        campaign: {}
    },
    campaigns: {
        data: []
    },
    campaign: {
        fotos: []
    },
	plus: {
        title: null,
        primeiro: null,
        segundo: null,
        terceiro: null
    },
    search: {
        user: {},
        cota: {}
    },
    random: [],
    error: {},
    success: false
}

const campaignsReducer = (state = initialState, { type, payload, isLoadMore, campaign_id }) => {
    switch (type) {

    case actionTypes.INDEX:
        if(isLoadMore) {
            payload.campaigns.data = state.campaigns.data.concat(payload.campaigns.data)
        }

        return { ...state, ...payload }

    case actionTypes.CHART:
        return {
            ...state,
            chart: {
                campaign: payload?.campaign,
                period: {
                    ...state.chart.period,
                    ...payload.period
                },
                hour: {
                    ...state.chart.hour,
                    ...payload.hour
                }
            }
        }

    case actionTypes.LOADING:
        let uid = state.campaigns.data.findIndex(item => item.id === payload.id)
        state.campaigns.data[uid].loading = payload.loading

        return { ...state, ...payload }

    case actionTypes.UPDATE:
        let index = state.campaigns.data.findIndex(item => item.id === payload.id)
        state.campaigns.data[index] = payload

        return {
            ...state,
            campaigns: {
                ...state.campaigns,
                data: [
                    ...[(index < 0) && payload],
                    ...state.campaigns.data
                ]
            }
        }

    case actionTypes.COUNT:
        let i = state.campaigns.data.findIndex(item => item.id === campaign_id)
        state.campaigns.data[i].pagos_count = payload.pagos_count;
        state.campaigns.data[i].reservados_count = payload.reservados_count
        state.campaigns.data[i].total_count = payload.total_count

        return {
            ...state
        }

    case actionTypes.DESTROY:
        state.campaigns.total = state.campaigns.total - 1

        return {
            ...state,
            campaigns: {
                ...state.campaigns,
                data: state.campaigns.data.filter(item => item.id !== payload)
            }
        }

    case actionTypes.CHANGE:
        return {
            ...state,
            chart: (payload === 'clear') ? initialState.chart : {
                ...state.chart,
                ...payload
            },
            plus: (payload === 'clear') ? {
                title: null,
                primeiro: null,
                segundo: null,
                terceiro: null
            } : {
                ...state.plus,
                ...payload
            },
            campaign: (payload === 'clear') ? { fotos: [] } : {
                ...state.campaign,
                ...payload
            }
        }

    case actionTypes.UPLOAD:
        return {
            ...state,
            campaign: {
                ...state.campaign,
                fotos: [
                    ...state.campaign.fotos.concat(payload)
                ]
            }
        }

    case actionTypes.DELETE_PHOTO:
        return {
            ...state,
            campaign: {
                ...state.campaign,
                fotos: state.campaign.fotos.filter(item => item.id !== payload)
            }
        }

    case actionTypes.REORDER_PHOTO:
        return {
            ...state,
            campaign: {
                ...state.campaign,
                fotos: payload
            }
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default campaignsReducer